// extracted by mini-css-extract-plugin
export default {"tab":"tab___mZisj","tab_active":"tab_active___zo3Lr"};